var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 9.4"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_maintenance_svg__cls-1",
    d: "M1.7.5h.5a.51.51 0 00-.28-.45.51.51 0 00-.52.05zm0 2.2h-.5a.51.51 0 00.26.44zm3.6 0l.24.44a.51.51 0 00.26-.44zm0-2.2l.3-.4a.51.51 0 00-.52 0 .51.51 0 00-.28.4zM3.9 8.9a.5.5 0 101 0zm-2.1 0a.5.5 0 001 0zm1.7-5.2l-.24.44.24.13.24-.13zM1 2.9a2.51 2.51 0 011-2L1.4.1A3.52 3.52 0 000 2.9zM1.2.5v2.2h1V.5zm4.6 2.2V.5h-1v2.2zM5 .9a2.49 2.49 0 011 2h1A3.52 3.52 0 005.6.1zm1 2a2.51 2.51 0 01-1.75 2.38l.3 1A3.51 3.51 0 007 2.9zM4.25 5.28a2.36 2.36 0 01-.75.12v1a3.6 3.6 0 001-.16zm-.35.48V8.9h1V5.76zm-.4-.36a2.56 2.56 0 01-1-.21l-.4.91a3.45 3.45 0 001.4.3zm-1-.21A2.51 2.51 0 011 2.9H0a3.5 3.5 0 002.1 3.2zm-.7.46V8.9h1V5.65zm3.26-3.39l-1.8 1 .48.88 1.8-1zm-1.32 1l-1.8-1-.48.88 1.8 1z",
    "data-name": "Layer 1"
  }))));
}

export default SvgCustomDnbMaintenance;